import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ExportChartButtonComponent } from "./export-chart-button/export-chart-button.component";
import { SharedModule } from '../shared.module';

@NgModule({
  declarations: [ExportChartButtonComponent],
  exports: [ExportChartButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports:[SharedModule,],
})
export class ComponentsModule {}
